import React from 'react'
import LoaderItem from 'blocks.app/loader/__item/loader__item'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'
import styles from './catalog__template_reportTasks.jcss'
import { cn } from 'ethcss'
import helpers from 'core/helpers'
import { ItemData } from '../../../../core/models/Template'
import moment from 'moment/moment'

export default {
    getMethod: 'getReportTasks',
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noReportTasks'),
    emptyIcon: 'not_allow',
    settingsPrefixes: 'reportTasks',
    listWrapperClassName: styles.listWrapperClassName,
    getItemModel: (dataItem: ItemData, getSelected: (item: ItemData) => boolean) => {
        const item = { ...dataItem }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    isEqual: (item: ItemData, prevItem: ItemData) => item.id === prevItem.id,
    onCreateListeners: [(cb: any, clearList: string[]) => api.addObserver('reportTaskCreated', cb, clearList)],
    onUpdateListeners: [(cb: any, clearList: string[]) => api.addObserver('reportTaskUpdated', cb, clearList)],
    onDeleteListeners: [(cb: any, clearList: string[]) => api.addObserver('reportTaskDeleted', cb, clearList)],
    isFolder: () => {},
    fields: () => [
        { id: 'status', name: translate('status') },
        { id: 'startTime', name: translate('startTime') },
        { id: 'endTime', name: translate('endTime') },
        { id: 'reportType', name: translate('reportType') },
        { id: 'reportView', name: translate('reportView') },
        { id: 'user', name: translate('user') },
        { id: 'createdAt', name: translate('createdAt') },
    ],
    init(callback: any) {
        //@ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    perPage: 60,
    list: {
        status: ({ status }: { status: string }) => {
            const isShowLoader = status === 'in_progress' || status === 'in_queue'

            return (
                <div className={cn(styles.statusWrapper)}>
                    {isShowLoader && <LoaderItem small={true} />}
                    {!isShowLoader && <div className={cn(styles.status, styles[status])} />}
                </div>
            )
        },
        startTime: ({ data }: { data: { startDate: string; endDate: string } }) => {
            return moment(data.startDate).format('HH:mm DD.MM.YYYY')
            //return helpers.getFormattedLocalDate(data.startDate, 'HH:mm DD/MM/YYYY')
        },
        endTime: ({ data }: { data: { startDate: string; endDate: string } }) => {
            return moment(data.endDate).format('HH:mm DD.MM.YYYY')
            //return helpers.getFormattedLocalDate(data.endDate, 'HH:mm DD.MM.YYYY')
        },
        reportType: ({ reportType }: { reportType: string }) => {
            return translate(reportType)
        },
        reportView: ({ reportView }: { reportView: string }) => {
            return translate('reportView' + String(reportView).charAt(0).toUpperCase() + String(reportView).slice(1))
        },
        user: ({ user }: { user: { email: string } }) => {
            return user.email
        },
        createdAt: ({ createdAt }: { createdAt: string }) => {
            return helpers.getFormattedLocalDate(createdAt, 'DD/MM/YYYY')
        },
    },
}
